const InitVars = {
  calledFromEF: false,
  sidebarOption: "",
};
export default InitVars;
